const AWSS3DocumentType = {
    Annualization: 'annualization',
    BIR1601: 'bir1601',
    BIR1603: 'bir1603',
    BIR1604: 'bir1604',
    BIR2316: 'bir2316',
    CompensationAndBenefits: 'compensationandbenefits',
    HR201: 'hr201',
    DepositSlips: 'depositslips',
    Paylips: 'payslips',
    PrintedInvoice: 'printedinvoice',
    ProofOfPayment: 'proofofpayment',
    Reimbursements: 'reimbursements',
    SOA: 'soa',
    TimeOffAttachment: 'timeoffattachment',
    AttendanceCorrectionsAttachment: 'attendancecorrectionsattachment'
}

export default AWSS3DocumentType